import { render, staticRenderFns } from "./AccountAutorespondersView.vue?vue&type=template&id=4da5bc93&"
import script from "./AccountAutorespondersView.vue?vue&type=script&lang=js&"
export * from "./AccountAutorespondersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da5bc93')) {
      api.createRecord('4da5bc93', component.options)
    } else {
      api.reload('4da5bc93', component.options)
    }
    module.hot.accept("./AccountAutorespondersView.vue?vue&type=template&id=4da5bc93&", function () {
      api.rerender('4da5bc93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/account/AccountAutorespondersView.vue"
export default component.exports